// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".items[data-v-1eae3687] {\n  margin-top: 50px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.item[data-v-1eae3687] {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.item p[data-v-1eae3687] {\n    flex: 1;\n}\n.item input[data-v-1eae3687] {\n    width: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
